import { render, staticRenderFns } from "./OverlayPromos.vue?vue&type=template&id=59d577ee"
import script from "./OverlayPromos.vue?vue&type=script&lang=js"
export * from "./OverlayPromos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports